import Error from '@/views/Error/index.vue'

const ErrorRouter = {
  path: '/error',
  name: 'Error',
  component: Error,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default ErrorRouter
